(function () {
  'use strict';
  const core = typeof module === 'object' && module.exports ? require('./bonanza-offer-core.js') : window.BonanzaOfferCore;
  const safeCartPath = value => typeof value === 'string' && /^(\/[a-z]{2}(?:-[a-z]{2})?)?\/cart$/i.test(value);

  async function prepareActivation({ readCart, config, cartUrl, confirm, isCurrent }) {
    if (!safeCartPath(cartUrl) || typeof readCart !== 'function' || !core) return { status: 'unavailable' };
    try {
      const result = core.evaluate(await readCart(), config);
      if (typeof isCurrent !== 'function' || !isCurrent()) return { status: 'cancelled' };
      if (!result.canApply) return { status: 'blocked', result };
      if (typeof confirm !== 'function' || confirm() !== true || !isCurrent()) return { status: 'cancelled', result };
      return { status: 'navigate', result, url: '/discount/NEW10?redirect=' + encodeURIComponent(cartUrl + '?bonanza_offer=NEW10') };
    } catch {
      return { status: 'unavailable' };
    }
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { prepareActivation };
    return;
  }
  if (!core || customElements.get('bonanza-offer-assistant')) return;
  let cartRevision = 0;

  class BonanzaOfferAssistant extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.busy = false;
      this.message = this.querySelector('[data-offer-message]');
      this.applyButton = this.querySelector('[data-offer-apply]');
      this.estimate = this.querySelector('[data-offer-estimate]');
      this.gap = this.querySelector('[data-offer-gap]');
      try {
        this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
        this.text = this.config.text;
        if (!safeCartPath(this.config.cartUrl) || !this.text) throw new Error('config');
        this.render(core.evaluate(JSON.parse(this.querySelector('[data-offer-cart]').textContent), this.config));
        this.applyButton.addEventListener('click', () => this.activate());
        this.querySelector('[data-offer-requested]').hidden = new URL(window.location.href).searchParams.get('bonanza_offer') !== 'NEW10';
      } catch {
        this.applyButton.hidden = true;
      }
    }

    money(amount) {
      return new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency: 'USD', currencyDisplay: 'code' }).format(amount / 100);
    }

    render(result) {
      this.hidden = result.state === 'empty';
      this.dataset.offerState = result.state;
      this.message.textContent = this.text[result.state] || this.text.unavailable;
      this.applyButton.hidden = !result.canApply;
      this.applyButton.disabled = this.busy;
      this.applyButton.textContent = this.busy ? this.text.checking : this.text.apply;
      this.estimate.hidden = result.discountedCents === null;
      this.estimate.textContent = result.discountedCents === null ? '' : this.text.estimate.replace('{amount}', this.money(result.discountedCents));
      const comparable = ['ready', 'shipping_risk'].includes(result.state);
      this.gap.hidden = !comparable;
      this.gap.textContent = comparable ? (result.subtotalCents < this.config.thresholdCents ? this.text.gap.replace('{amount}', this.money(this.config.thresholdCents - result.subtotalCents)) : this.text.threshold) : '';
    }

    invalidate() {
      this.applyButton.hidden = true;
      this.applyButton.disabled = true;
      this.estimate.hidden = true;
      this.gap.hidden = true;
      if (this.text) this.message.textContent = this.text.changed;
    }

    async activate() {
      if (this.busy || this.applyButton.hidden) return;
      this.busy = true;
      const revision = cartRevision;
      this.applyButton.disabled = true;
      this.applyButton.textContent = this.text.checking;
      const outcome = await prepareActivation({
        config: this.config,
        cartUrl: this.config.cartUrl,
        readCart: async () => {
          const response = await fetch(this.config.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
          if (!response.ok) throw new Error('cart_unavailable');
          return response.json();
        },
        confirm: () => window.confirm(this.text.confirm),
        isCurrent: () => this.isConnected && revision === cartRevision
      });
      if (!this.isConnected) return;
      this.busy = false;
      if (revision !== cartRevision) return;
      if (outcome.status === 'navigate') {
        window.location.assign(outcome.url);
        return;
      }
      if (outcome.result) this.render(outcome.result);
      else this.render({ state: 'unavailable', canApply: false, subtotalCents: null, discountedCents: null, gapCents: null });
    }
  }

  customElements.define('bonanza-offer-assistant', BonanzaOfferAssistant);
  const changing = event => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('cart-remove-button') && !event.target.matches('[name="updates[]"]')) return;
    cartRevision++;
    document.querySelectorAll('bonanza-offer-assistant').forEach(element => element.invalidate());
  };
  document.addEventListener('input', changing, true);
  document.addEventListener('change', changing, true);
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('cart-remove-button')) changing(event);
  }, true);
  window.addEventListener('pagehide', () => {
    cartRevision++;
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    cartRevision++;
    document.querySelectorAll('bonanza-offer-assistant').forEach(element => element.invalidate());
  });
}());
